import api from './api';

export interface IContratadoAnoPedidoMaterialLog {
    index: number;
    codigoPacote: string,
    ordemCompraNumero: number;
    pcmNumero: number;
    anoRequisicaoCompra: number;
    requisitadoAnoQuantidade: number;
}


export const getAllContratadoAnoPedidoMaterialLog = () => api.get<Array<IContratadoAnoPedidoMaterialLog>>('contratadoAno/getAllContratadoAnoPedidoMaterialLog');
export const processarPendenciaContratadoAnoPedidoMaterial = () => api.get<any>('contratadoAno/processarPendenciaContratadoAnoPedidoMaterial');


